import styled from '@emotion/styled'
import { Typography, TypographyProps } from '../Typography'

const StyledH1 = styled(Typography)`
  margin: ${props => `0px 0px ${props.theme.spacing['700']}`};
`

export type H1Props = TypographyProps<'h1'>

export const H1 = ({
  children,
  className,
  color = 'neutral',
  'data-qa': dataQa,
  size = '700',
  variant = 'heading',
  weight = 'regular',
  ...htmlGlobalAttributes
}: H1Props) => (
  <StyledH1
    as='h1'
    className={className}
    color={color}
    data-qa={dataQa}
    size={size}
    variant={variant}
    weight={weight}
    {...htmlGlobalAttributes}
  >
    {children}
  </StyledH1>
)

H1.displayName = 'H1'
